export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#64CCC9',
    contrastText: '#FFFFFF',
    light: '#e0f4f4',
  },
  secondary: {
    main: '#003865',
    contrastText: '#002855',
  },
  text: {
    primary: '#003865',
    light: '#64748B',
    secondary: '#003865',
    default: '#141B22',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#A1E0DF',
    primary: '#003865',
    paper: '#FFF',
    default: '#FFF',
    header: 'rgba(241, 241, 241, 0.6)',
    footer: '#F1F1F1',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#64CCC9',
    tableSubhead: '#F1FAFE',
    arrow: '#10B7F2',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: 'rgba(176, 224, 230, 0.4)',
  },
  verticalBar: {
    used: '#64CCC9',
    unused: '#e0f4f4',
    unlimited: '#C0C0C0',
  }
};
